export const SUPPORTS_ARRAY_PROTOTYPE_PUSH = "push" in Array.prototype;
